import { Injectable } from "@angular/core";
import { Platform } from "ionic-angular";
import { AngularFire } from "angularfire2";
import { assign, clone } from "lodash";
import * as md5 from "md5";
import * as firebase from "firebase";

@Injectable()
export class AssetService {
  protected static readonly DIR_IMAGES = "images";
  protected static readonly DIR_ARTICLE_IMAGES = "articles";

  storageRef: any;

  constructor(public platform: Platform, public af: AngularFire) {
    this.storageRef = firebase.storage().ref();
  }

  // File helpers
  loadFileFromEvent(event: any): Promise<any> {
    if (!event.target.files || !event.target.files.length) {
      return Promise.reject(new Error("No file was chosen."));
    }

    return this.loadFileFromObject(event.target.files[0]);
  }

  loadFileFromObject(fileObject: any): Promise<any> {
    return new Promise((resolve, reject) => {
      let file = this.getFormattedFile(fileObject);
      let fileReader = new FileReader();

      fileReader.addEventListener("load", () => {
        if (!fileReader.result) {
          return reject("Could not load chosen file.");
        }

        file.data = fileReader.result;

        return resolve(file);
      });

      fileReader.readAsDataURL(fileObject);
    });
  }

  getFormattedFile(fileObject: any): any {
    return {
      name: fileObject.name,
      type: fileObject.type,
      size: fileObject.size,
    };
  }

  // Upload helpers
  uploadArticleImage(file: any, options: any = null) {
    return this.uploadFile(file, this.articleImagesDir, options);
  }

  uploadImage(file: any, options: any = null) {
    return this.uploadFile(file, this.imagesDir, options);
  }

  uploadFile(data: any, dir: string, options: any = null): Promise<any> {
    return new Promise((resolve, reject) => {
      let file = clone(data);
      file.name = md5(file.data);
      file.path = `${dir}/${file.name}`;

      options = assign(
        {
          contentType: file.type,
        },
        options || {},
      );

      let uploadTask = this.storageRef
        .child(file.path)
        .putString(file.data, "data_url", options);

      uploadTask.on(
        "state_changed",
        snapshot => {
          // console.log("UPLOAD PROGRESS", snapshot);
        },
        error => {
          return reject(error);
        },
        success => {
          return resolve(uploadTask.snapshot);
        },
      );
    });
  }

  // Getters and setters
  get articleImagesDir() {
    return `${this.imagesDir}/${AssetService.DIR_ARTICLE_IMAGES}`;
  }

  get imagesDir() {
    return AssetService.DIR_IMAGES;
  }
}



// WEBPACK FOOTER //
// ./src/providers/asset.ts